import { action } from "typesafe-actions";
import {
  CHECK_LOGIN,
  CHECK_LOGIN_FAILED,
  CHECK_LOGIN_SUCCESS,
  CLEAR_TRIAL_EXPIRED,
  LOGIN,
  LOGIN_ERROR,
  LOGIN_SUCCESS,
  LOGIN_WITH_REFRESH_TOKEN,
  LOGOUT,
  SET_USER,
  TOKEN_REFRESHED,
  TRIAL_EXPIRED,
} from "./authActionTypes";
import { AuthTokens } from "Types/auth";
import { ApiAuthUser } from "@incendium/api";

export const login = (args: {
  email: string;
  password: string;
  onSuccess?: (res: AuthTokens) => void;
  onFail?: (e: any) => void;
}) => action(LOGIN, args);
export const loginSuccess = (args: AuthTokens) =>
  action(LOGIN_SUCCESS, args);

export const tokenRefreshed = (args: AuthTokens) => {
  return action(TOKEN_REFRESHED, args);
};
export const checkLoginSuccess = (args: AuthTokens) => {
  return action(CHECK_LOGIN_SUCCESS, args);
};
export const checkLoginFailed = () => {
  return action(CHECK_LOGIN_FAILED);
};
export const loginError = () => action(LOGIN_ERROR);
export const logout = () => action(LOGOUT);
export const checkLogin = () => action(CHECK_LOGIN);

export const setUser = (args: ApiAuthUser) => action(SET_USER, args);

export const loginWithRefreshToken = (refreshToken: string) =>
  action(LOGIN_WITH_REFRESH_TOKEN, { refreshToken });

export const trialExpired = () => action(TRIAL_EXPIRED);

export const clearTrialExpired = () => action(CLEAR_TRIAL_EXPIRED);
